import React, { Component } from 'react';

import PropTypes from 'prop-types';

import A from 'wanderu-component-react-router-link';
import {
    Button,
    Lightbox,
    MarkdownContent,
    Modal,
} from 'wanderu-components';

import styles from './SEOModal.scss';

class SEOModal extends Component {
    static propTypes = {
        modalText: PropTypes.string.isRequired,
        topButtonLink: PropTypes.string.isRequired,
        topButtonText: PropTypes.string.isRequired,
        bottomButtonLink: PropTypes.string.isRequired,
        bottomButtonText: PropTypes.string.isRequired,
    };

    state = {
        isOpen: true,
    };

    _onClose = () => {
        this.setState(() => ({
            isOpen: false,
        }));
    };

    render() {
        const {
            modalText,
            topButtonLink,
            topButtonText,
            bottomButtonLink,
            bottomButtonText,
        } = this.props;
        const {
            isOpen,
        } = this.state;

        if (!isOpen) {
            return null;
        }

        return (
            <div
                aria-describedby="seoModal"
                role="alertdialog"
            >
                <Modal>
                    <Lightbox onHide={this._onClose}>
                        <MarkdownContent className={styles.modalText}>
                            {modalText}
                        </MarkdownContent>
                        <div className={styles.options}>
                            <Button>
                                <A
                                    className={styles.link}
                                    href={topButtonLink}
                                >
                                    {topButtonText}
                                </A>
                            </Button>
                            <Button>
                                <A
                                    className={styles.link}
                                    href={bottomButtonLink}
                                >
                                    {bottomButtonText}
                                </A>
                            </Button>
                        </div>
                    </Lightbox>
                </Modal>
            </div>
        );
    }
}

export default SEOModal;
